/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ListDefinition } from '../models/ListDefinition';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class ListDefinitionService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get all list definitions that belong to the specified form definition and organization.
     * @param formDefinitionGuid
     * @param workflowDefinitionGuid
     * @param currentOrganizationGuid
     * @returns ListDefinition OK
     * @throws ApiError
     */
    public getAllListDefinitions(
        formDefinitionGuid?: string,
        workflowDefinitionGuid?: string,
        currentOrganizationGuid?: string,
    ): CancelablePromise<Array<ListDefinition>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/ListDefinition/GetAllListDefinitions',
            query: {
                'formDefinitionGuid': formDefinitionGuid,
                'workflowDefinitionGuid': workflowDefinitionGuid,
                'currentOrganizationGuid': currentOrganizationGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get all list definitions that are used for PDF codes.
     * @param workflowDefinitionGuid
     * @param currentOrganizationGuid
     * @returns ListDefinition OK
     * @throws ApiError
     */
    public getPdfCodeListDefinitions(
        workflowDefinitionGuid?: string,
        currentOrganizationGuid?: string,
    ): CancelablePromise<Array<ListDefinition>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/ListDefinition/GetPdfCodeListDefinitions',
            query: {
                'workflowDefinitionGuid': workflowDefinitionGuid,
                'currentOrganizationGuid': currentOrganizationGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get a single list definition by its Guid.
     * @param listDefinitionGuid
     * @returns ListDefinition OK
     * @throws ApiError
     */
    public getListDefinition(
        listDefinitionGuid: string,
    ): CancelablePromise<ListDefinition> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/ListDefinition/{listDefinitionGuid}',
            path: {
                'listDefinitionGuid': listDefinitionGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Delete a list definition.
     * @param listDefinitionGuid
     * @returns any OK
     * @throws ApiError
     */
    public deleteListDefinition(
        listDefinitionGuid: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/ListDefinition/{listDefinitionGuid}',
            path: {
                'listDefinitionGuid': listDefinitionGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Create a new list definition.
     * @param requestBody
     * @returns ListDefinition OK
     * @throws ApiError
     */
    public createListDefinition(
        requestBody?: ListDefinition,
    ): CancelablePromise<ListDefinition> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/ListDefinition/CreateListDefinition',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Update a list definition.
     * @param listDefinitionGuid
     * @param requestBody
     * @returns ListDefinition OK
     * @throws ApiError
     */
    public updateListDefinition(
        listDefinitionGuid?: string,
        requestBody?: ListDefinition,
    ): CancelablePromise<ListDefinition> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/ListDefinition/UpdateListDefinition',
            query: {
                'listDefinitionGuid': listDefinitionGuid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
